export const regexpTag = '[object RegExp]';
export const stringTag = '[object String]';
export const numberTag = '[object Number]';
export const booleanTag = '[object Boolean]';
export const argumentsTag = '[object Arguments]';
export const symbolTag = '[object Symbol]';
export const dateTag = '[object Date]';
export const mapTag = '[object Map]';
export const setTag = '[object Set]';
export const arrayTag = '[object Array]';
export const functionTag = '[object Function]';
export const arrayBufferTag = '[object ArrayBuffer]';
export const objectTag = '[object Object]';
export const errorTag = '[object Error]';
export const dataViewTag = '[object DataView]';
export const uint8ArrayTag = '[object Uint8Array]';
export const uint8ClampedArrayTag = '[object Uint8ClampedArray]';
export const uint16ArrayTag = '[object Uint16Array]';
export const uint32ArrayTag = '[object Uint32Array]';
export const bigUint64ArrayTag = '[object BigUint64Array]';
export const int8ArrayTag = '[object Int8Array]';
export const int16ArrayTag = '[object Int16Array]';
export const int32ArrayTag = '[object Int32Array]';
export const bigInt64ArrayTag = '[object BigInt64Array]';
export const float32ArrayTag = '[object Float32Array]';
export const float64ArrayTag = '[object Float64Array]';

export function getTag<T>(value: T) {
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]';
  }
  return Object.prototype.toString.call(value);
}
